import { styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2, 0),
  gap: theme.spacing(3),
  cursor: 'pointer',
}));

export const Inner = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    height: 'min-content',
    alignItems: 'center',
  },
}));

export const Info = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    flex: 3,
  },
}));

export const PriceAndButton = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    flex: 2,
  },
}));

export const Price = styled('div')(({ theme }) => ({
  flex: '1 1 0',
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    alignItems: 'center',
  },
}));
